import React, { useEffect } from 'react';
import { getIsSlateSkinFromDomain } from '|/context';
import { getCvAccessToken } from '|/helpers/access-token';
import { refreshTokenIfMissing } from '|/helpers/axios';

const RedirectToHome = () => {
  useEffect(() => {
    if (getIsSlateSkinFromDomain()) {
      void refreshTokenIfMissing().then(() => {
        // Success leaves a usable access token → reload into the flow. Failure paths
        // (no refresh token / 4XX / 5XX) already navigated to login/speedbump.
        if (getCvAccessToken()) {
          window.location.href = `${window.location.origin}/purchase`;
        }
      });
      return;
    }

    const query = `?openAccountModal=signIn&ReturnUrl=${encodeURIComponent('/purchase')}`;
    window.location.href = `${window.location.origin}/${query}`;
  }, []);

  return null;
};

const AccountLogin = () => {
  return <RedirectToHome />;
};

export default AccountLogin;
